import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

import { PDFImageProps } from '../../../utils/models';
import { getFileUploadTypes } from '../../../utils/utilities';
import { IMAGE_LIMITS } from '../../../utils/constants';

import toastService from '../../../services/toastService';

interface StateData { 
	pIDNumber: string; 
	pIDImages: PDFImageProps[]; 
}

interface Props {
	initialPIDData: StateData;
	onAdd: (data: StateData) => void;
}

class PIDImageForm extends Form {
	state = {
		data: {
			pIDNumber: '',
			pIDImages: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		pIDNumber: Joi.string().min(4).required().label('P&ID Number'),
		pIDImages: Joi.array().min(1).max(IMAGE_LIMITS.PID_IMAGE).required().label('P&ID Image'),
	};

	static propTypes = {
		initialPIDData: PropTypes.object,
		onAdd: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialPIDData) {
			this.setState({ data: this.props.initialPIDData });
		}
	}

	componentDidUpdate(prevProps: Props, prevState: { data: StateData }) {
		if (prevProps.initialPIDData && this.props.initialPIDData) {
			if (prevProps.initialPIDData.pIDNumber === this.props.initialPIDData.pIDNumber) return;

			if (this.state.data.pIDNumber.length === 0 && this.state.data.pIDImages.length === 0) {
				this.setState({ data: this.props.initialPIDData });
			}
		}
	}

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);
		toastService.success('P&ID Saved Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderInput({
					type: 'text',
					name: 'pIDNumber',
					placeholder: 'Enter P&ID Number',
					label: 'P&ID Number',
				})}

				<div className="my-4 divider"></div>

				{this.renderFileInput({
					max: IMAGE_LIMITS.PID_IMAGE,
					hideCaption: true,
					multiple: IMAGE_LIMITS.PID_IMAGE > 1,
					name: 'pIDImages',
					accept: 'image/*,application/pdf',
					label: 'P&ID',
					sublabel: 'Upload P&ID Image',
					types: getFileUploadTypes(),
				})}

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save P&ID')}
				</div>
			</form>
		);
	}
}

export default PIDImageForm;
